// extracted by mini-css-extract-plugin
export default {"button":"styles_button__E5+zg","menuTitle":"styles_menuTitle__rZMVL","title":"styles_title__ULEVr"};